import { call, put, takeEvery } from "redux-saga/effects";
import axios from "axios";
import { FETCH_DASHBOARD_DATA } from "./actionTypes";
import {
  fetchDashboardSuccess,
  fetchDashboardFailure,
} from "./actions";

function* fetchDashboardDataSaga() {
  try {
    const token = localStorage.getItem("authToken");
    const response = yield call(axios.get, process.env.REACT_APP_WEB_APP_URL + "/api/web/dashboard",{
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
    yield put(fetchDashboardSuccess(response.data));
  } catch (error) {
    yield put(fetchDashboardFailure(error.message));
  }
}

export default function* dashboardSaga() {
  yield takeEvery(FETCH_DASHBOARD_DATA, fetchDashboardDataSaga);
}
